import React from "react";
import PropTypes from "prop-types";
import { resolveExamples } from "../templateVariables";
import styles from "./TemplateBodyPreview.module.css";

/**
 * Preview da mensagem em formato de bolha de WhatsApp.
 *
 * Resolve TANTO aliases ({{nome}}, {{serviço}}, {{horário}}) QUANTO os
 * placeholders numéricos do backend ({{1}}, {{2}}, {{3}}) por valores de
 * exemplo. Isso permite reuso no modal (texto com aliases, em tempo real) e no
 * card (texto numérico salvo vindo da API).
 *
 * É puramente visual e não tem semântica de input — `aria-hidden` no SVG.
 */
export default function TemplateBodyPreview({ text, emptyHint }) {
  const resolved = resolveExamples(text || "").trim();

  return (
    <div className={styles.wrapper} aria-label="Pré-visualização da mensagem">
      <div className={styles.header}>
        <span className={styles.headerIcon} aria-hidden="true">
          {/* Ícone genérico de chat (não usa marca registrada). */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
          </svg>
        </span>
        <span className={styles.headerLabel}>Mensagem para o cliente</span>
      </div>

      <div className={styles.bubble}>
        {resolved ? (
          <p className={styles.bubbleText}>{resolved}</p>
        ) : (
          <p className={styles.bubblePlaceholder}>
            {emptyHint || "A mensagem aparecerá aqui conforme você escreve."}
          </p>
        )}
        <span className={styles.bubbleMeta} aria-hidden="true">
          14:02
          <span className={styles.checks}>✓✓</span>
        </span>
      </div>
    </div>
  );
}

TemplateBodyPreview.propTypes = {
  /** Texto cru — pode conter aliases ou placeholders numéricos. */
  text: PropTypes.string,
  /** Texto mostrado quando `text` está vazio. */
  emptyHint: PropTypes.string,
};
